import { STRING, FLOAT, INTEGER, BOOLEAN, GEOMETRY, DATETIME } from './attribute_type';
import Geometry from 'ol/geom/Geometry';

class Property {

	constructor(name, required, type, multiValue) {
		this.name = name;
		this.required = required;
		this.type = type;
		this.index = 0;
		this.multiValue = multiValue;
	}
	
	getIndex() {
		return this.index;
	}
	
	getName() {
		return this.name;
	}
	
	isRequired() {
		return this.required;
	}

	isMultiValue() {
		return this.multiValue;		
	}

	getType() {
		return this.type || -1;
	}
	
	updateIndex( index ) { 
		this.index = index;
	}
	
	updateType( nextValue ) {
		const hasValue = !isNullOrUndefined(nextValue);
		if( this.required && !hasValue ) {
			this.required = false;
		}
				
		if( !this.multiValue && Array.isArray(nextValue) ) {
			this.multiValue = true;
		}
		
		if( hasValue && this.multiValue ) {
			this.type = updatePropertyType(this.type, getArrayProperty( nextValue ) );
	    } else if( hasValue ) {
			this.type = updatePropertyType(this.type, getPropertyType( nextValue )); 
		}
	}	
}

const isNullOrUndefined = value => value === null || value === undefined;

const getPropertyType = (value) => {
	let type = undefined;
	const valueType = typeof value;
	
	if( value instanceof Geometry ) {
		type = GEOMETRY;
	} else if( value instanceof Date ) {
		type = DATETIME;
	} else if( valueType === 'number' ) {
		type = FLOAT;
		
		if( value % 1 === 0 ) {
			type = INTEGER;
		}				
	} else if( valueType === 'boolean' ) {
		type = BOOLEAN;
	} else if( valueType === 'string' ) {
		type = STRING;
	} else {
		console.debug( value );
	}
	
	return type;
}

// test valid updates of geometry types
const updatePropertyType = (currentValue, newValue) => {
	let returnValue = undefined;
	
	if( (currentValue === INTEGER && newValue === FLOAT) || (currentValue === FLOAT && newValue === INTEGER) ) {
		returnValue = FLOAT; 	
	} else if( currentValue === newValue ) {
		returnValue = newValue;
	} else if( newValue === STRING ) {
		returnValue = STRING;
	} else {
		console.log("Unsupported switch: %s to %s", currentValue, newValue);
	}
	
	return returnValue;
}

const getArrayProperty = (value) => {
	let type = null;
	
	for(let i = 0; i < value.length; i++ ) {
		const entryType = getPropertyType(value[i]);
		
		if( type ) {
			type = updatePropertyType(type, entryType);
		} else {
			type = entryType;
		}
	}
	
	return type;
}

const create = (name, value) => {
	let type = null;
	let multiValue = false;	
	
	if( Array.isArray(value) ) {
		multiValue = true;
		type = getArrayProperty( value );
	} else {
		type = getPropertyType( value );		
	} 
	
	
	return new Property(name, !!value, type, multiValue);
}

export { 
	create, Property, getPropertyType
}